import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

import ContactPersonModal from "@components/ContactPersonModal/ContactPersonModal";
import ContactCard from "@components/shared/ContactCard/ContactCard";
import {
  ContactPersonInfoType,
  ContactPersonPropType,
} from "@models/shared/shared.model";

const ContactPerson: React.FC<ContactPersonPropType> = ({
  contactList,
  isVisible,
}) => {
  const { t } = useTranslation();

  const [showContactPersonModal, setShowContactPersonModal] = useState(false);
  const [contactPersonInfo, setContactPersonInfo] =
    useState<ContactPersonInfoType>({} as ContactPersonInfoType);

  const handleNavigate = (contactPersonInfo: ContactPersonInfoType) => {
    setContactPersonInfo(contactPersonInfo);
    setShowContactPersonModal(true);
  };

  const closeContactPersonModal = () => {
    setContactPersonInfo({} as ContactPersonInfoType);
    setShowContactPersonModal(false);
  };

  return isVisible ? (
    <>
      <div
        className="fg-loc-custom-block fg-scroll-listing-bottom"
        data-testid="contact-person-test"
      >
        <h5>{t("contactPerson")}</h5>
        <ul className="fg-contact-user-scroll">
          {contactList?.map((contact: ContactPersonInfoType, index: number) => (
            <ContactCard
              contactDetail={contact}
              handleNavigate={() => handleNavigate(contact)}
              key={index}
            />
          ))}
        </ul>
      </div>
      <Modal
        size="md"
        isOpen={showContactPersonModal}
        toggle={closeContactPersonModal}
      >
        <ModalHeader toggle={closeContactPersonModal}>
          {t("contactPerson")}
        </ModalHeader>
        <ModalBody>
          <ContactPersonModal contactDetail={contactPersonInfo} />
        </ModalBody>
      </Modal>
    </>
  ) : (
    <></>
  );
};

export default ContactPerson;
